import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { getUNQIndex } from '@bingads-webui-react/unified-notification-queue';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';

export const Placeholder = withDefaultStyles(({ i18n, classes }) => {
  const btnClassNames = classNames('unified-notification-queue-trigger-btn', 'trigger-queue-close');
  const bellClassNames = classNames('alert-icon', 'notification-bell-inactive');

  return (
    <div className={`${classes.UNQIndex}`}>
      <div className="unified-notification-queue-container" style={{ alignItems: 'center' }}>
        <div>
          <div className="unified-notification-queue" >
            <div className="bingads-popover-wrapper" >
              <div
                className="target-wrapper"
                role="button"
              >
                <div className="unified-notification-queue-trigger">
                  <button className={btnClassNames}>
                    <div>
                      <span className={bellClassNames} />
                      <div className="unified-notification-queue-trigger-text"> {i18n.getString(_TL_('Notifications'))} </div>
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}, getUNQIndex);


Placeholder.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
};
